import './QuantitativeDimensionalIndicatorUnit.css';

import { Box } from '@mui/material';
import QuantitativeIndicatorUnit from './QuantitativeIndicatorUnit';
import { StackedLineChart } from '@mui/icons-material';
import { generateClassName } from '../../../b2b-common/helpers';

const QuantitativeDimensionalIndicatorUnit = ({ indicator, showIcon = true, className = null }) => {
    return (
        <Box className={generateClassName('quantitative-dimensional-indicator-unit','',className)} display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
            <QuantitativeIndicatorUnit indicator={indicator} showIcon={showIcon} />
            <Box className="quantitative-dimensional-indicator-unit-dimensions" display="flex" flexDirection="row" alignItems="center" justifyContent="flex-start" gap={1}>
                {showIcon && (
                    <StackedLineChart />
                )}
                {indicator.dimensionalType.dimensionTypeName}
            </Box>
        </Box>
    );
}

export default QuantitativeDimensionalIndicatorUnit;